var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wbsvg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 30",
    width: 25,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    fill: "#000000",
    strokeWidth: 0,
    d: "M9 6 L7 6 L10 2 L13 6 L11 6 L11 25 L2 22  L9 19 L9 18 L2 18 L2 17 L9 17 L9 18 L2 18 L2 17 L9 17 L9 16 L2 16 L2 15 L9 15 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.dfac465454ce3d226d80d2bcc2eb443f.svg";
export { ForwardRef as ReactComponent };